export const savePolygonsToLocalStorage = (drawControl) => {
  const allPolygons = drawControl.getAll();

  if (allPolygons.features.length > 0) {
    localStorage.setItem('allPolygons', JSON.stringify(allPolygons));
  }
};

export const deletePolygonFromLocaleStorage = (deletedPolygonId) => {
  const allPolygons = localStorage.getItem('allPolygons');

  if (allPolygons) {
    try {
      const parsedData = JSON.parse(allPolygons);

      const filteredData = parsedData.features.filter((feature) => feature.id !== deletedPolygonId);

      const updated = { ...parsedData, features: filteredData };

      localStorage.setItem('allPolygons', JSON.stringify(updated));
    } catch (error) {
      console.error('Error during setting filtered polygons to localStorage', error);
    }
  }
};

export const updatePolygonInLocalStorage = (
  updatedPolygon,
  updatedPolygonId,
  updatedPolygonCoordinates,
) => {
  const allPolygons = localStorage.getItem('allPolygons');

  if (allPolygons) {
    try {
      const parsedData = JSON.parse(allPolygons);

      const updatedData = parsedData.features.map((feature) => {
        if (feature.id === updatedPolygonId) {
          return { ...updatedPolygon, id: feature.id, coordinates: updatedPolygonCoordinates };
        }

        return feature;
      });

      const updated = { ...parsedData, features: updatedData };

      localStorage.setItem('allPolygons', JSON.stringify(updated));
    } catch (error) {
      console.error('Error during setting filtered polygons to localStorage', error);
    }
  }
};

export const saveVisibleFeaturesinLocalStorage = (visibleFeatures) => {
  if (visibleFeatures) {
    localStorage.setItem('visibleFeatures', JSON.stringify(visibleFeatures));
  }
};
